import { getErrorInfoPanelMessages } from "./PanelErrorMessage";
import { getSuccessInfoPanelMessages } from "./PanelSuccessMessage";

export const getPanelMessages = () => ({
  ...getErrorInfoPanelMessages(),
  ...getSuccessInfoPanelMessages(),
});
